import { useMedia } from "react-media";

export function useBreakpoint() {
  // Breakpoint values match the configured tailwind breakpoints
  const xxs = useMedia({ query: "(max-width: 320px)" });
  const xs = useMedia({ query: "(max-width: 480px)" });
  const sm = useMedia({ query: "(max-width: 640px)" });
  const md = useMedia({ query: "(max-width: 768px)" });
  const lg = useMedia({ query: "(max-width: 1024px)" });
  const xl = useMedia({ query: "(max-width: 1280px)" });
  const xxl = useMedia({ query: "(max-width: 1536px)" });

  return {
    xxs,
    xs,
    sm,
    md,
    lg,
    xl,
    xxl,
  };
}

export function useExclusiveBreakpoint() {
  // (width < 1024px) is not supported by old browsers and 0.99px has a safari rounding bug
  // 0.98 is what tailwind uses internally
  const xxs = useMedia({ query: "(max-width: 319.98px)" });
  const xs = useMedia({ query: "(max-width: 479.98px)" });
  const sm = useMedia({ query: "(max-width: 639.98px)" });
  const md = useMedia({ query: "(max-width: 767.98px)" });
  const lg = useMedia({ query: "(max-width: 1023.98px)" });
  const xl = useMedia({ query: "(max-width: 1279.98px)" });
  const xxl = useMedia({ query: "(max-width: 1535.98px)" });

  return {
    xxs,
    xs,
    sm,
    md,
    lg,
    xl,
    xxl,
  };
}

export function useMinBreakpoint() {
  const xxs = useMedia({ query: "(min-width: 320px)" });
  const xs = useMedia({ query: "(min-width: 480px)" });
  const sm = useMedia({ query: "(min-width: 640px)" });
  const md = useMedia({ query: "(min-width: 768px)" });
  const lg = useMedia({ query: "(min-width: 1024px)" });
  const xl = useMedia({ query: "(min-width: 1280px)" });
  const xxl = useMedia({ query: "(min-width: 1536px)" });

  return {
    xxs,
    xs,
    sm,
    md,
    lg,
    xl,
    xxl,
  };
}
